import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { IonSlides, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { API } from 'aws-amplify';
import * as moment from 'moment';
import { GameonPage } from 'src/app/createteams/gameon/gameon.page';
import { ConfirmationPage } from '../confirmation/confirmation.page';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-contest-detail',
  templateUrl: './contest-detail.page.html',
  styleUrls: ['./contest-detail.page.scss'],
})
export class ContestDetailPage implements OnInit {
  @ViewChild('slides', { static: true }) slider: IonSlides;
  public env = environment;
  matchInfo: string; lastKey: any;
  test_contestUsers: any[] = [];
  contestDetails: any;
  contestListDetails: any;
  matchDetails: any;
  contestUsers: any[] = [];
  progressPercent: number;
  language: string;
  firstCurrentDate: Date;
  secondCurrentDate: Date;
  hoursCurrent: number;
  minutesCurrent: number;
  secondCurrent: number;
  IntervalVar: any;
  joinContestIs: boolean = false;
  scoringRules: any[] = [];
  footerButton: string = "CREATE YOUR TEAM";
  private scrollDepthTriggered = false;
  join;
  totalEntries: any;
  selectedTeams ;
  cacheCleartimestamp : number = new Date().getTime();
  clicked;
  isFromDeepLink:boolean = false;
  deepLinkMatchId:any;
  deepLinkContestId:any;
  timeStampStart:any;

  constructor(
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    public modelCtrl: ModalController,
    private http: HttpClient
  ) { 
    this.isFromDeepLink = this.activatedRoute.snapshot.queryParamMap.get('isFromDeepLink') ? true : false;
    this.deepLinkMatchId = this.activatedRoute.snapshot.queryParamMap.get('deepLinkMatchId') ? Number(this.activatedRoute.snapshot.queryParamMap.get('deepLinkMatchId')) : null;
    this.deepLinkContestId = this.activatedRoute.snapshot.queryParamMap.get('deepLinkContestId') ? this.activatedRoute.snapshot.queryParamMap.get('deepLinkContestId') : '';
    this.getPerticularMatchDetail();
  }

  async ionViewWillEnter() {
    this.clicked = false;
    this.language = localStorage.getItem("language");
    if (this.language === 'hn') {
      this.translate.use('hn');
    }
    else if (this.language === 'en') {
      this.translate.use('en');
    }
    else if (this.language === 'kn') {
      this.translate.use('kn');
    }
    this.matchInfo = "info";
    this.cacheCleartimestamp = new Date().getTime();
    if(this.isFromDeepLink){
      await this.getTeamsData();
      await this.getContestDetails();
   } else{
     this.getCurrentTimer();
     this.getTeamsData();
     this.getContestDetails();
   }
  }

  getPrizePerUser(prize, type = 'minValue') {
    return Math.floor(prize[type] / ((prize.max - prize.min) + 1))
  }

  async ngOnInit() {
    this.clicked = false;
    if(!this.isFromDeepLink){
      this.contestListDetails = JSON.parse(this.activatedRoute.snapshot.queryParamMap.get('contestDetail'));
      this.matchDetails = JSON.parse(this.activatedRoute.snapshot.queryParamMap.get('matchDetails'));
    }
    console.log("Match Details",this.matchDetails?.matchId);
    console.log("Contest Details",this.contestListDetails);
    this.join =  this.activatedRoute.snapshot.queryParamMap.get('join');
    console.log(this.join);
    // if(this.isFromDeepLink){
    //    await this.getPerticularMatchDetail();
    //    await this.getCurrentTimer();
    //    await this.getTeamsData();
    //    await this.getContestDetails();
    //    await this.scoringEn();
    // } else{
    //   await this.getCurrentTimer();
    //   await this.getTeamsData();
    //   await this.getContestDetails();
    // }
  }

  async getPerticularMatchDetail() {
    console.log(this.matchDetails?.matchId);
    const apiName = 'matchesApi';
    const matchId = !this.isFromDeepLink ? this.matchDetails?.matchId : this.deepLinkMatchId;
    const path = `/matches/${matchId}/?gameId=1&sportId=1`;
    const myInit = {
      headers: {},
      response: true,
      queryStringParameters: {}
    };
    API.get(apiName, path, myInit).then((res) => {
      this.matchDetails = res?.data?.data;
      if(this.isFromDeepLink){
        this.getCurrentTimer();
      }
      if(this.language == 'hn'){
        this.scoringhn();
      }else if(this.language == 'kn'){
        this.scoringkn();
      } else {
        this.scoringEn();
      }
     this.timeStampStart = res?.data?.data?.timeStampStart;
     console.log("timeStampStart==========>", 'color:blue', this.timeStampStart);

      }).catch((error) => {
      console.log(error);
    });
  }

  changeSource(event, name) {
     event.target.src = `../../assets/img/person-avatar.png`;
  }

  segmentChanged() {
    console.log(this.matchInfo);
    if (this.matchInfo == "winnings") {
      this.getContestDetails();
    }
    if (this.matchInfo == "info") {
      if(this.language == 'en'){
        this.scoringEn();
      }
    else  if(this.language == 'hn'){
        this.scoringhn();
      }else if(this.language == 'kn'){
        this.scoringkn();
      }
      
      console.log("lang",this.language);
      
    }
    if (this.matchInfo == "entries") {
      this.getContestusers();
    }
  }

  async getTeamsData() {
    const apiName = 'fantasyApi';
    const path = "/fantasy/lineup";
    const matchId = !this.isFromDeepLink ? this.matchDetails['matchId'] : this.deepLinkMatchId;
    const myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        sportId: 1,
        gameId: 1,
        matchId: matchId
      }
    };
    API.get(apiName, path, myInit).then((data) => {
      let temp = data.data.data;
      console.log(temp);
      temp.forEach(data => {
        console.log(data.lineUpId);
        this.selectedTeams = data.lineUpId;
      })
      
      if (temp && temp !== null && temp.length !== 0) {
        this.footerButton = "MY TEAM(S)"
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  async scoringEn() {
  await  this.http
      .get<any>(`${environment.s3AssetsUrl}/site/assets/cricketscoring_english.json?${(new Date().getTime())}`)
      // .map(data => data.json())
      .subscribe(data => {
        if (this.matchDetails?.matchFormat == "Test" || this.matchDetails?.matchFormat == "Women TEST" || this.matchDetails?.matchFormat == "First Class" || this.matchDetails?.matchFormat == "TEST" || this.matchDetails?.matchFormat == "test" || this.matchDetails?.matchFormat == "Woman TEST") {
          this.scoringRules = [];
          for (let x in data.content.test) {
            console.log("players",x);
            
            data.content.test.hasOwnProperty(x) && this.scoringRules.push(data.content.test[x]);
          }
        } else if (this.matchDetails?.matchFormat == "T20" || this.matchDetails?.matchFormat == "T20I" || this.matchDetails?.matchFormat == "Woman T20" || this.matchDetails?.matchFormat == "Others" || this.matchDetails?.matchFormat == "Youth T20" || this.matchDetails?.matchFormat == "T20(Domestic)" || this.matchDetails?.matchFormat == "t20"|| this.matchDetails?.matchFormat == "T20I (Twenty20 International)" || this.matchDetails?.matchFormat == "Women T20") {
          this.scoringRules = [];
          for (let x in data.content.tt) {
            data.content.tt.hasOwnProperty(x) && this.scoringRules.push(data.content.tt[x]);
          }
        } else if (this.matchDetails?.matchFormat == "One_day" || this.matchDetails?.matchFormat == "ODI"|| this.matchDetails?.matchFormat == "List A" || this.matchDetails?.matchFormat == "Women ODI" || this.matchDetails?.matchFormat == "Youth ODI" || this.matchDetails?.matchFormat == "ODI (One Day International)" || this.matchDetails?.matchFormat == "Woman ODI" || this.matchDetails?.matchFormat == "One Day" ) {
          this.scoringRules = [];
          for (let x in data.content.one_day) {
            data.content.one_day.hasOwnProperty(x) && this.scoringRules.push(data.content.one_day[x]);
          }
        } else if (this.matchDetails?.matchFormat == "T10" || this.matchDetails?.matchFormat == "t10" || this.matchDetails?.matchFormat == "Women T10" || this.matchDetails?.matchFormat == "Youth T10" || this.matchDetails?.matchFormat == "Woman T10") {
          this.scoringRules = [];
          for (let x in data.content.t10) {
            data.content.t10.hasOwnProperty(x) && this.scoringRules.push(data.content.t10[x]);
          }
        }
      })
  }
  async scoringhn() {
    await  this.http
        .get<any>(`${environment.s3AssetsUrl}/site/assets/cricketscoring_hindi.json?${(new Date().getTime())}`)
        // .map(data => data.json())
        .subscribe(data => {
          console.log(data);
          if (this.matchDetails?.matchFormat == "Test" || this.matchDetails?.matchFormat == "Women TEST" || this.matchDetails?.matchFormat == "First Class" || this.matchDetails?.matchFormat == "TEST" || this.matchDetails?.matchFormat == "test" || this.matchDetails?.matchFormat == "Woman TEST") {
            this.scoringRules = [];
            for (let x in data.content.test) {
              console.log("players",x);
              
              data.content.test.hasOwnProperty(x) && this.scoringRules.push(data.content.test[x]);
            }
          } else if (this.matchDetails?.matchFormat == "T20" || this.matchDetails?.matchFormat == "T20I" || this.matchDetails?.matchFormat == "Woman T20" || this.matchDetails?.matchFormat == "Others" || this.matchDetails?.matchFormat == "Youth T20" || this.matchDetails?.matchFormat == "T20(Domestic)" || this.matchDetails?.matchFormat == "t20"|| this.matchDetails?.matchFormat == "T20I (Twenty20 International)" || this.matchDetails?.matchFormat == "Women T20") {
            this.scoringRules = [];
            for (let x in data.content.tt) {
              data.content.tt.hasOwnProperty(x) && this.scoringRules.push(data.content.tt[x]);
            }
          } else if (this.matchDetails?.matchFormat == "One_day" || this.matchDetails?.matchFormat == "ODI"|| this.matchDetails?.matchFormat == "List A" || this.matchDetails?.matchFormat == "Women ODI" || this.matchDetails?.matchFormat == "Youth ODI" || this.matchDetails?.matchFormat == "ODI (One Day International)" || this.matchDetails?.matchFormat == "Woman ODI" || this.matchDetails?.matchFormat == "One Day" ) {
            this.scoringRules = [];
            for (let x in data.content.one_day) {
              data.content.one_day.hasOwnProperty(x) && this.scoringRules.push(data.content.one_day[x]);
            }
          } else if (this.matchDetails?.matchFormat == "T10" || this.matchDetails?.matchFormat == "t10" || this.matchDetails?.matchFormat == "Women T10" || this.matchDetails?.matchFormat == "Youth T10" || this.matchDetails?.matchFormat == "Woman T10") {
            this.scoringRules = [];
            for (let x in data.content.t10) {
              data.content.t10.hasOwnProperty(x) && this.scoringRules.push(data.content.t10[x]);
            }
          }
        })
    }
    async scoringkn() {
      await  this.http
          .get<any>(`${environment.s3AssetsUrl}/site/assets/cricketscoring_kannada.json?${(new Date().getTime())}`)
          // .map(data => data.json())
          .subscribe(data => {
            console.log(data);
            if (this.matchDetails?.matchFormat == "Test" || this.matchDetails?.matchFormat == "Women TEST" || this.matchDetails?.matchFormat == "First Class" || this.matchDetails?.matchFormat == "TEST" || this.matchDetails?.matchFormat == "test" || this.matchDetails?.matchFormat == "Woman TEST") {
              this.scoringRules = [];
              for (let x in data.content.test) {
                console.log("players",x);
                
                data.content.test.hasOwnProperty(x) && this.scoringRules.push(data.content.test[x]);
              }
            } else if (this.matchDetails?.matchFormat == "T20" || this.matchDetails?.matchFormat == "T20I" || this.matchDetails?.matchFormat == "Woman T20" || this.matchDetails?.matchFormat == "Others" || this.matchDetails?.matchFormat == "Youth T20" || this.matchDetails?.matchFormat == "T20(Domestic)" || this.matchDetails?.matchFormat == "t20"|| this.matchDetails?.matchFormat == "T20I (Twenty20 International)" || this.matchDetails?.matchFormat == "Women T20") {
              this.scoringRules = [];
              for (let x in data.content.tt) {
                data.content.tt.hasOwnProperty(x) && this.scoringRules.push(data.content.tt[x]);
              }
            } else if (this.matchDetails?.matchFormat == "One_day" || this.matchDetails?.matchFormat == "ODI"|| this.matchDetails?.matchFormat == "List A" || this.matchDetails?.matchFormat == "Women ODI" || this.matchDetails?.matchFormat == "Youth ODI" || this.matchDetails?.matchFormat == "ODI (One Day International)" || this.matchDetails?.matchFormat == "Woman ODI" || this.matchDetails?.matchFormat == "One Day" ) {
              this.scoringRules = [];
              for (let x in data.content.one_day) {
                data.content.one_day.hasOwnProperty(x) && this.scoringRules.push(data.content.one_day[x]);
              }
            } else if (this.matchDetails?.matchFormat == "T10" || this.matchDetails?.matchFormat == "t10" || this.matchDetails?.matchFormat == "Women T10" || this.matchDetails?.matchFormat == "Youth T10" || this.matchDetails?.matchFormat == "Woman T10") {
              this.scoringRules = [];
              for (let x in data.content.t10) {
                data.content.t10.hasOwnProperty(x) && this.scoringRules.push(data.content.t10[x]);
              }
            }
          })
      }
     

  async confirmation(entryAmount, contestId, cashType,contestListDetails) {
    console.log("contestListDetails : ", contestListDetails);
    //event.stopPropagation()
    if (this.footerButton === 'CREATE YOUR TEAM') {
      this.router.navigate(['createteams'], { queryParams: { matchDetails: JSON.stringify(this.matchDetails), submitButton: "Submit LineUp", entryAmount: entryAmount, contestId: contestId, cashType: cashType,reset:true,bonusallowed: contestListDetails.bonusAllowed } });
    } else {
      const model = await this.modelCtrl.create({
        component: ConfirmationPage,
        showBackdrop: true,
        cssClass: 'modal-class',
        //data pass 
        componentProps: { entryAmount: entryAmount, matchId: this.matchDetails['matchId'], contestId: contestId, matchDetails: this.matchDetails, routerLink: "contestDetail", cashType: cashType,bonusallowed: contestListDetails.bonusAllowed }
      });
      model.onDidDismiss().then(data => {
        this.clicked = false;
        if (data.role !== 'backdrop') {
          console.log(data);
          this.joinContestIs = data?.data
          console.log(this.joinContestIs);
          if (this.joinContestIs) {
            this.gameOn();
          }
        }
      });
      await model.present();
    }
  }

  async gameOn() {
    this.clicked = false;
    const model = await this.modelCtrl.create({
      component: GameonPage,
      showBackdrop: true,
      cssClass: 'modal_gameOn',
      componentProps: { matchDetails: this.matchDetails },
      backdropDismiss: false
    });
    model.onDidDismiss();
    await model.present();
  }

  public backClick(): void {
    this.location.back();
  }

  
  getCounter(tick) {
    return timer(0, tick);
  }

  countDown: Subscription;
  counter: number;
  tick = 1000;
  async getCurrentTimer() {
    this.counter = 0;
    const start = new Date().getTime();
    const end = new Date(this.matchDetails['timeStampStart'] * 1000).getTime();
    // const end = new Date(new Date().getTime() + 63000).getTime();
    const diff = end - start;
    this.counter = Math.floor(diff / 1000);
    this.countDown = this.getCounter(this.tick).subscribe(() => {
      this.counter--;
      // console.log(this.counter)
      if (this.counter <= 0) {
        this.unSubscribeCoundown();
      }
    });
  }

  isTimer(time) {
    let diff = this.getDiffInSeconds(time);
    diff /= (60 * 60);
    const hours = Math.abs(Math.round(diff));
    if (diff <= 0) {
      return false;
    } else if (hours <= 24 && hours >= 0) {
      return true;
    } else {
      return false;
    }
  }

  getDiffInSeconds(time) {
    const now = new Date(); //todays date
    const end = new Date(time * 1000); // another date
    return (end.getTime() - now.getTime()) / 1000;;
  }  

  unSubscribeCoundown() {
    if (this.countDown) {
      this.countDown.unsubscribe();
    }
  }

  ionViewWillLeave() {
    this.unSubscribeCoundown();
  }

  async getContestDetails() {
    const apiName = 'contestsApi';
    const contestId = !this.isFromDeepLink ? this.contestListDetails.contestId : this.deepLinkContestId;
    const matchId = !this.isFromDeepLink ? this.matchDetails['matchId'] : this.deepLinkMatchId;

    const path = `/contests/${contestId}/?sportId=1&gameId=1&matchId=${matchId}`;
    const myInit = {
      headers: {},
      response: true,
    };
    API.get(apiName, path, myInit)
      .then(response => {
        this.contestListDetails = response?.data?.data;
        this.contestDetails = response?.data?.data;
        console.log("contestDetails");
        console.log(this.contestDetails);
      })
      .catch(error => {
        console.log(error);
      });
  }

  async allScrolling($event) {
    if (this.matchInfo == "entries") {
      //console.log($event);
      if (this.scrollDepthTriggered) {
        return;
      }
      if ($event.target.localName != "ion-content") {
        return;
      }
      const scrollElement = await $event.target.getScrollElement();
      const scrollHeight = scrollElement.scrollHeight - scrollElement.clientHeight;
      const currentScrollDepth = $event.detail.scrollTop;
      const targetPercent = 90;
      let triggerDepth = ((scrollHeight / 100) * targetPercent);
      //console.log(currentScrollDepth, triggerDepth);
      if (currentScrollDepth > triggerDepth) {
        console.log(`Scrolled to ${targetPercent}%`);
        this.scrollDepthTriggered = true;
        //const index = await this.slider.getActiveIndex();
        if (this.lastKey) {
          this.getContestusersWithLastKey();
        } else {
          this.getContestusers();
        }
      }
    }
  }

  getContestusersWithLastKey() {
    console.log("getContestusersWithLastKey");
    // &startKey=${this.lastKey}
    const apiName = 'fantasyApi';
    const matchId = !this.isFromDeepLink ? this.contestListDetails['matchId'] : this.deepLinkMatchId;
    const contestId = !this.isFromDeepLink ? this.contestListDetails['contestId'] : this.deepLinkContestId;
    const path = `/fantasy/contest/users?sportId=1&gameId=1&matchId=${matchId}&contestId=${contestId}&startKey=${this.lastKey}`;
    const myInit = {
      headers: {},
      response: true,
    };
    API.get(apiName, path, myInit)
      .then(response => {
        console.log(response);
        this.lastKey = response?.data?.data?.lastKey;
        this.contestUsers = response?.data?.data.users;
        const contestUsers = this.contestUsers.filter(({ uid: id1 }) => !this.test_contestUsers.some(({ uid: id2 }) => id2 === id1));
        this.test_contestUsers = [...this.test_contestUsers, ...contestUsers];
        this.getPer();
        this.scrollDepthTriggered = false;
        console.log(this.test_contestUsers.length);
        
      })
      .catch(error => {
        console.log(error);
      });
  }

  getContestusers() {
    console.log("getContestusers");
    const apiName = 'fantasyApi';
    const matchId = !this.isFromDeepLink ? this.matchDetails?.matchId : this.deepLinkMatchId;
    const contestId = !this.isFromDeepLink ? this.contestListDetails['contestId'] : this.deepLinkContestId;
    const path = `/fantasy/contest/users?sportId=1&gameId=1&matchId=${matchId}&contestId=${contestId}`;
    const myInit = {
      headers: {},
      response: true,
    };
    API.get(apiName, path, myInit)
      .then(response => {
        console.log(response);
        this.lastKey = response?.data?.data?.lastKey;
        this.totalEntries = response?.data?.data?.totalEntries
        this.contestUsers = response?.data?.data.users;
        const contestUsers = this.contestUsers.filter(({ uid: id1 }) => !this.test_contestUsers.some(({ uid: id2 }) => id2 === id1));
        this.test_contestUsers = [...this.test_contestUsers, ...contestUsers];
        this.getPer();
        this.scrollDepthTriggered = false;

      })
      .catch(error => {
        console.log(error);
      });
  }

  getPer() {
    const per: number = Number(((this.contestUsers['totalEntries'] * 100) / this.contestListDetails['maxEntries']).toFixed(2));
    this.progressPercent = per / 100;
  }
}
